import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { mdiArrowLeft } from '@mdi/js'
import { Studio } from '@/modules/Studios/types'
import { StudioApi } from '@/enitites/studio'
import BKConfirmationDialog from '@/shared/ui/modals/BKConfirmationDialog.vue'
import Bugsnag from '@bugsnag/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioSettingsPage',
  setup(__props) {

const studio = ref<Studio>()
const isLoading = ref(false)
const showConfirmationDialog = ref(false)

const route = useRoute()
const router = useRouter()

const buttonText = computed(() => {
  if (!studio.value) return 'Deactivate Studio'
  return studio.value.status === 'draft' ? 'Publish Studio' : 'Deactivate Studio'
})

const confirmationTitle = computed(() => {
  if (!studio.value) return ''
  return studio.value.status === 'draft' ? `Publish ${studio.value.name}?` : `Deactivate ${studio.value.name}?`
})

const confirmationText = computed(() => {
  if (!studio.value) return ''
  return studio.value.status === 'draft'
    ? 'This will make your studio visible to the public.'
    : 'This will hide your studio from the public.'
})

const confirmationButtonText = computed(() => {
  if (!studio.value) return 'Confirm'
  return studio.value.status === 'draft' ? 'Publish' : 'Deactivate'
})

const currentRoute = computed(() => route.matched.find((routeItem) => routeItem.parent))
const childRoutes = computed(
  () => router.options.routes?.find((item) => item.name === 'StudioSettings')?.children || []
)

onMounted(async () => {
  try {
    studio.value = await StudioApi.fetchStudio(route.params.id)
    if (!studio.value) {
      await router.push({ name: 'Studios' })
    }
  } catch (error) {
    Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
      event.addMetadata('studio', {
        context: 'Error fetching studio',
        studioId: route.params.id,
      })
    })
    await router.push({ name: 'Studios' })
  }
})

async function updateStudioData() {
  if (!studio.value) return
  isLoading.value = true
  try {
    const resp = await StudioApi.updateStudio(studio.value)
    if (resp) {
      await store.dispatch('showAlertToast', 'changesSaved')
    }
  } catch (error) {
    Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
      event.addMetadata('studio', {
        context: 'Error updating studio',
        studioId: studio.value?.id,
      })
    })
    await store.dispatch('showAlertToast', 'error')
  } finally {
    isLoading.value = false
  }
}

function openConfirmationDialog() {
  showConfirmationDialog.value = true
}

async function toggleStudioStatus() {
  if (!studio.value) return

  isLoading.value = true
  try {
    if (studio.value.status === 'draft') {
      // Publish the studio
      await StudioApi.publishStudio(studio.value.id)
      studio.value.status = 'published'
      await store.dispatch('showAlertToast', 'studioPublished')
    } else {
      // Set to draft
      await StudioApi.unpublishStudio(studio.value.id)
      studio.value.status = 'draft'
      await store.dispatch('showAlertToast', 'studioDeactivated')
    }
  } catch (error) {
    Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
      event.addMetadata('studio', {
        context: 'Error toggling studio status',
        studioId: studio.value?.id,
        targetStatus: studio.value?.status === 'draft' ? 'published' : 'draft',
      })
    })
    await store.dispatch('showAlertToast', 'error')
  } finally {
    isLoading.value = false
    showConfirmationDialog.value = false
  }
}

return { __sfc: true,studio, isLoading, showConfirmationDialog, route, router, buttonText, confirmationTitle, confirmationText, confirmationButtonText, currentRoute, childRoutes, updateStudioData, openConfirmationDialog, toggleStudioStatus, mdiArrowLeft, BKConfirmationDialog }
}

})